"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _knotchincWebReactComponents = require("@bit/knotchinc.web-react-components.tooltip");

var _Utils = require("./helpers/Utils.js");

var _styled = require("./styled.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var CellReferrer = function CellReferrer(props) {
  var withImage = props.withImage,
      data = props.data,
      header = props.header,
      headerText = props.headerText,
      handleClick = props.handleClick,
      highlighted = props.highlighted,
      width = props.width,
      sortable = props.sortable,
      sortOrder = props.sortOrder,
      sorted = props.sorted;

  if (!header && !(0, _Utils.validateString)(data)) {
    return /*#__PURE__*/_react["default"].createElement(_styled.StyledCell, {
      width: width
    }, "-");
  }

  return header ? /*#__PURE__*/_react["default"].createElement(_styled.StyledHeaderCell, {
    onClick: handleClick,
    width: width,
    sortable: sortable,
    sortOrder: sortOrder
  }, headerText) : /*#__PURE__*/_react["default"].createElement(_styled.StyledCell, {
    padding: "0",
    highlited: highlighted,
    width: width,
    height: "100%",
    sorted: sorted
  }, withImage ? /*#__PURE__*/_react["default"].createElement(_styled.StyledCellImage, null, data.image_url ? /*#__PURE__*/_react["default"].createElement(_styled.Background, {
    url: data.image_url,
    opacity: "0.3"
  }) : /*#__PURE__*/_react["default"].createElement(_styled.ReferrerPlaceholderImage, null)) : null, /*#__PURE__*/_react["default"].createElement(_styled.StyledCellTextContainer, null, data, data === 'direct/none' && /*#__PURE__*/_react["default"].createElement(_knotchincWebReactComponents.TooltipWithIcon, {
    iconSize: "small",
    type: "direct_none_traffic"
  })));
};

var _default = CellReferrer;
exports["default"] = _default;

//# sourceMappingURL=CellReferrer.js.map